export default __webpack_public_path__ + "img/3cdc57972fef0bb00bf165f589fbf044.jpg";